import { OptionWithHint } from '#components/patterns/forms/select/option/OptionWithHint.tsx';
import { SelectItem } from '#components/patterns/forms/select/select-item/SelectItem.tsx';
import { Select } from '#components/patterns/forms/select/select/Select.tsx';

type Props = {
  className?: string;
  defaultValue: 'Endpoint' | 'Admin';
  disabled?: boolean;
  onChange: (value: 'Endpoint' | 'Admin') => void;
  adminProviderHint?: string;
  disableAdminProvider?: boolean;
};

export function SelectProviderType(props: Props) {
  const { adminProviderHint, disableAdminProvider, ...selectProps } = props;
  return (
    <Select
      label="Provider type"
      {...selectProps}
      helpTip="Admin providers are used to log into admin.defined.net. Endpoint providers are used in DNClient Desktop to enroll endpoints into your network."
    >
      <SelectItem value="Admin" disabled={disableAdminProvider}>
        {adminProviderHint ?
          <OptionWithHint value="Admin" hint={adminProviderHint} />
        : 'Admin'}
      </SelectItem>

      <SelectItem value="Endpoint">Endpoint</SelectItem>
    </Select>
  );
}
